import { EmptyState } from 'ui/emptyState';
import { ListsEmptyState } from 'ui/illustrations';
import { WebLink } from 'ui/theme';
import { EmptyStateSubtitle, EmptyStateWrapper } from '../../AudienceSelection.styled';

export const CAMPAIGN_EDITOR_LISTS_EMPTY_STATE_TITLE = "We can't seem to find your lists";

export const ErrorEmptyState = () => {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <EmptyStateWrapper data-test="campaign-editor-lists-empty-state">
      <EmptyState
        Illustration={ListsEmptyState}
        title={CAMPAIGN_EDITOR_LISTS_EMPTY_STATE_TITLE}
        subtitle={
          <EmptyStateSubtitle>
            <WebLink
              href="#"
              onClick={handleRefresh}
              data-test="campaign-editor-lists-empty-state-refetch"
            >
              Refresh this page
            </WebLink>{' '}
            to try again.
          </EmptyStateSubtitle>
        }
      />
    </EmptyStateWrapper>
  );
};
